export default __webpack_public_path__ + "static/media/gideoneunane.6ce845a2.png";